export const DAMO_AUTH_PATHS = {
  SIGN_IN: 'sign-in',
  REDIRECT: 'redirect',
  FORGOT_PASSWORD: 'forgot-password',
  PASSWORD_RESET: 'password-reset',
  VERIFY_EMAIL: 'verify-email',
  REVERT_MFA: 'revert-mfa',
  AUTH_ACTION: 'action',
} as const;
